import { Component } from '@angular/core';

@Component({
  selector: 'app-chat-bot-asesor-v2-borrar-chat',
  templateUrl: './chat-bot-asesor-v2-borrar-chat.component.html',
})
export class ChatBotAsesorV2BorrarChatComponent { }
